<div id="crop-health-note-delete-confirm">
  <p class="description">{{ description | translate }}</p>
  <div class="mb-2">
    <p-button
      severity="danger"
      [label]="confirmBtnLabel | translate"
      id="delete-note-submit-btn"
      (onClick)="close(true)" />
  </div>

  <p-button
    severity="secondary"
    [label]="cancelBtnLabel | translate"
    id="delete-note-cancel-btn"
    (onClick)="close()" />
</div>
